import '@/assets/main.css'
// import '@babel/polyfill'
import Vue from 'vue'
import '@/plugins/axios'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import moment from 'moment'
import VeeValidate from 'vee-validate'
import VuePlugin from 'vue-flag-icon'
import ShortKey from 'vue-shortkey'
import VueCarousel from 'vue-carousel'
import TextField from '@/components/TextField.vue'
import Card from '@/components/Card.vue'
import Editor from '@/components/Editor.vue'
import Form from '@/components/Form.vue'
import TimeInput from '@/components/TimeInput.vue'
import DateInput from '@/components/DateInput.vue'
import ClockWidget from '@/modules/widget/components/ClockWidget.vue'
import WeatherWidget from '@/modules/widget/components/WeatherWidget.vue'
import UserRegistrationStatsWidget from '@/modules/user/widgets/UserRegistrationStatsWidget.vue'
import vuetify from './plugins/vuetify'
import DatetimePicker from 'vuetify-datetime-picker';

moment.locale('es')

Vue.use(ShortKey as any)
Vue.use(VeeValidate)
Vue.use(VuePlugin as any)
Vue.use(VueCarousel as any)
Vue.use(DatetimePicker as any)

Vue.component('TextField', TextField)
Vue.component('Card', Card)
Vue.component('Editor', Editor)
Vue.component('Form', Form)
Vue.component('TimeInput', TimeInput)
Vue.component('DateInput', DateInput)
Vue.component('ClockWidget', ClockWidget)
Vue.component('WeatherWidget', WeatherWidget)
Vue.component('UserRegistrationStatsWidget', UserRegistrationStatsWidget)

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
